import { Check } from 'lucide-react';
import { CatalogPlan, planFeatures } from '@/client/types/promotion-pricing/catalog';

interface PlanFeatureListProps {
  plan: CatalogPlan;
}

/** Renders the plan's `description_json` bullets, or nothing when absent. */
export const PlanFeatureList = ({ plan }: PlanFeatureListProps) => {
  const features = planFeatures(plan);
  if (!features.length) return null;

  return (
    <ul className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
      {features.map((feature, i) => (
        <li key={`${feature}-${i}`} className="flex items-start gap-2 text-sm text-gray-600">
          <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-500" />
          <span>{feature}</span>
        </li>
      ))}
    </ul>
  );
};
